export default function arrayMoveImmutable(array, fromIndex, toIndex) {
  const arrayNew = [...array];
  const startIndex = fromIndex < 0 ? arrayNew.length + fromIndex : fromIndex;

  if (startIndex >= 0 && startIndex < arrayNew.length) {
    const endIndex = toIndex < 0 ? arrayNew.length + toIndex : toIndex;
    const [item] = arrayNew.splice(fromIndex, 1);
    arrayNew.splice(endIndex, 0, item);
  }
  return arrayNew;
}
